var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Firmware-version" },
    [
      _c("pageTitle"),
      _c(
        "business-group",
        {
          ref: "businessGroup",
          attrs: {
            tableConfig: { ..._vm.tableConfig },
            formConfig: { ..._vm.formConfig },
          },
          scopedSlots: _vm._u([
            {
              key: "formSlot",
              fn: function (formSlot) {
                return [
                  _c(
                    "a-form-item",
                    [
                      _c(
                        "a-select",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["keyword"],
                              expression: "['keyword']",
                            },
                          ],
                          staticStyle: { width: "150px" },
                          attrs: { placeholder: "请选择维护状态" },
                        },
                        _vm._l(_vm.DeviceSelect, function (el) {
                          return _c(
                            "a-select-option",
                            { key: el.id, attrs: { value: el.id } },
                            [_vm._v(_vm._s(el.name))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
            {
              key: "maintenanceStatus",
              fn: function (record) {
                return [
                  _vm._v(
                    " " + _vm._s(record.maintenanceStatus ? "是" : "否") + " "
                  ),
                ]
              },
            },
            {
              key: "action",
              fn: function (record) {
                return [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "link" },
                      on: {
                        click: function ($event) {
                          return _vm.edit(record)
                        },
                      },
                    },
                    [_vm._v("编辑")]
                  ),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "link" },
                      on: {
                        click: function ($event) {
                          return _vm.del(record)
                        },
                      },
                    },
                    [_vm._v("删除")]
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "formRight" },
            [
              _c(
                "a-button",
                { attrs: { type: "primary" }, on: { click: _vm.add } },
                [_vm._v("新增")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.visible,
            destroyOnClose: "",
            title: _vm.title,
            maskClosable: false,
            width: "780px",
          },
          on: {
            ok: function ($event) {
              return _vm.submitForm("ruleForm")
            },
            cancel: function ($event) {
              return _vm.resetForm("ruleForm")
            },
          },
        },
        [
          _c(
            "a-form-model",
            {
              ref: "ruleForm",
              staticClass: "Firmware-version_ruleForm",
              attrs: {
                title: _vm.title,
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-col": { span: 7 },
                "wrapper-col": { span: 14 },
              },
            },
            [
              _c(
                "a-form-model-item",
                { attrs: { label: "APP类型", prop: "osType" } },
                [
                  _c(
                    "a-select",
                    {
                      attrs: {
                        placeholder: "请选择APP类型",
                        disabled: !_vm.isAddnew,
                      },
                      on: { change: _vm.showOpsSystemType },
                      model: {
                        value: _vm.ruleForm.osType,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "osType", $$v)
                        },
                        expression: "ruleForm.osType",
                      },
                    },
                    _vm._l(_vm.osTypeArray, function (el) {
                      return _c(
                        "a-select-option",
                        {
                          key: el.label,
                          attrs: { value: el.value, title: el.label },
                        },
                        [_vm._v(" " + _vm._s(el.label) + " ")]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "APP升级类型", prop: "sellitemmenu" } },
                [
                  _c(
                    "a-select",
                    {
                      attrs: { placeholder: "请选择APP升级类型" },
                      model: {
                        value: _vm.ruleForm.sellitemmenu,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "sellitemmenu", $$v)
                        },
                        expression: "ruleForm.sellitemmenu",
                      },
                    },
                    _vm._l(_vm.sellitemmenuArray, function (el) {
                      return _c(
                        "a-select-option",
                        { key: el.label, attrs: { value: el.value } },
                        [_vm._v(" " + _vm._s(el.label) + " ")]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "APP来源", prop: "appSource" } },
                [
                  _c(
                    "a-select",
                    {
                      attrs: { placeholder: "请选择APP来源" },
                      model: {
                        value: _vm.ruleForm.appSource,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "appSource", $$v)
                        },
                        expression: "ruleForm.appSource",
                      },
                    },
                    _vm._l(_vm.appSourceArray, function (el) {
                      return _c(
                        "a-select-option",
                        { key: el.label, attrs: { value: el.value } },
                        [_vm._v(" " + _vm._s(el.label) + " ")]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: this.isShowOpsSystemType,
                      expression: "this.isShowOpsSystemType",
                    },
                  ],
                  attrs: { label: "操作系统类型", prop: "opsSystemType" },
                },
                [
                  _c(
                    "a-select",
                    {
                      attrs: { placeholder: "请选择操作系统类型" },
                      model: {
                        value: _vm.ruleForm.opsSystemType,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "opsSystemType", $$v)
                        },
                        expression: "ruleForm.opsSystemType",
                      },
                    },
                    _vm._l(_vm.opsSystemArray, function (el) {
                      return _c(
                        "a-select-option",
                        { key: el.label, attrs: { value: el.value } },
                        [_vm._v(" " + _vm._s(el.label) + " ")]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "版本号", prop: "versionCode" } },
                [
                  _c("a-input", {
                    attrs: {
                      type: "text",
                      placeholder: "请输入版本号",
                      disabled: !_vm.isAddnew,
                    },
                    model: {
                      value: _vm.ruleForm.versionCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "versionCode", $$v)
                      },
                      expression: "ruleForm.versionCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "维护状态", prop: "maintenanceStatus" } },
                [
                  _c(
                    "a-radio-group",
                    {
                      attrs: { name: "radioGroup", "default-value": true },
                      model: {
                        value: _vm.ruleForm.maintenanceStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "maintenanceStatus", $$v)
                        },
                        expression: "ruleForm.maintenanceStatus",
                      },
                    },
                    [
                      _c("a-radio", { attrs: { value: true } }, [_vm._v("是")]),
                      _c("a-radio", { attrs: { value: false } }, [
                        _vm._v("否"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "上传更新包", prop: "downloadUrl" } },
                [
                  _c(
                    "a-upload",
                    {
                      staticClass: "m-upload",
                      attrs: {
                        name: "avatar",
                        "before-upload": _vm.beforeUpload,
                        remove: _vm.remove,
                        "file-list": _vm.files,
                        disabled: !_vm.isAddnew,
                      },
                      model: {
                        value: _vm.ruleForm.downloadUrl,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "downloadUrl", $$v)
                        },
                        expression: "ruleForm.downloadUrl",
                      },
                    },
                    [
                      _vm.files.length <= 0
                        ? _c("a-icon", {
                            attrs: { type: _vm.upLoading ? "loading" : "plus" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "更新说明", prop: "updateLog" } },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "a-button",
                        {
                          staticClass: "editable-add-btn",
                          on: { click: _vm.handleAdd },
                        },
                        [_vm._v(" Add ")]
                      ),
                      _c("a-table", {
                        attrs: {
                          bordered: "",
                          "data-source": _vm.updateLogDataSource,
                          columns: _vm.updateLogDataColumn,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "lang",
                            fn: function (text, record, index) {
                              return [
                                _c("editable-select-cell", {
                                  attrs: {
                                    allowCustom: true,
                                    value: record.lang,
                                    options: _vm.langs,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.onCellChange(
                                        "lang",
                                        $event,
                                        index
                                      )
                                    },
                                  },
                                }),
                              ]
                            },
                          },
                          {
                            key: "describe",
                            fn: function (text, record, index) {
                              return [
                                _c("editable-cell", {
                                  attrs: { text: text, value: record.describe },
                                  on: {
                                    change: function ($event) {
                                      return _vm.onCellChange(
                                        "describe",
                                        $event,
                                        index
                                      )
                                    },
                                  },
                                }),
                              ]
                            },
                          },
                          {
                            key: "operation",
                            fn: function (text, record) {
                              return [
                                _vm.updateLogDataSource.length
                                  ? _c(
                                      "a-popconfirm",
                                      {
                                        attrs: { title: "Sure to delete?" },
                                        on: {
                                          confirm: () =>
                                            _vm.onDelete(record.key),
                                        },
                                      },
                                      [
                                        _c(
                                          "a",
                                          { attrs: { href: "javascript:;" } },
                                          [_vm._v("Delete")]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "a-form-model-item",
                {
                  attrs: {
                    label: "富文本详细说明(官网)",
                    prop: "updateDetailRichText",
                  },
                },
                [
                  _vm.visible
                    ? _c("edit-components", {
                        attrs: {
                          content: _vm.ruleForm.updateDetailRichText,
                          "html-change": _vm.onUpdateDetailRichTextChange,
                          uploadImg: _vm.uploadRichTextImg,
                          "upload-path": _vm.richTextUploadPath,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }